
import { EventEmitter } from "events"
import u from "umbrellajs"

import PageView from "app/tracking/google/page_view"
import PageInstance from "app/page_instance/index"


// Just using existing element, no other special reason for choosing it
// But don't change once setup, GTM related
const getDataContainerElement = () => {
  return u("#app-data-container")
}
/* eslint-disable no-unused-vars */
enum CurrentModeTrackingValues {
  MAP  =     "map",
  LIST =     "list",
  CARD =     "hybrid",
}
/* eslint-enable no-unused-vars */
const CurrentModeTracking = {
  ATTR_NAME: "current-listing-search-page-map-or-list-mode",

  ATTR_VALUES: CurrentModeTrackingValues,
}


const ee = new EventEmitter()

ee.on("card_mode", () => {
  PageView.track(track_path("/mode/card"))

  setCurrentModeAttrForTracking(CurrentModeTracking.ATTR_VALUES.CARD)
})

ee.on("map_mode", () => {
  PageView.track(track_path("/mode/map"))

  setCurrentModeAttrForTracking(CurrentModeTracking.ATTR_VALUES.MAP)
})

ee.on("list_mode", () => {
  PageView.track(track_path("/mode/list"))

  setCurrentModeAttrForTracking(CurrentModeTracking.ATTR_VALUES.LIST)
})


// region Implementation Details
function track_path(mode_path: string) {
  const type_path = PageInstance.isRentalPage() ?
    "/pages/city-listing-search-pages-for-rent" :
    "/pages/city-listing-search-pages-for-sale"

  return [
    "/fake-path",
    "/apps/spacious-web-app",
    type_path,
    mode_path,
  ].join("")
}

function setCurrentModeAttrForTracking(val: CurrentModeTrackingValues): void {
  const $data_container_el = getDataContainerElement()

  $data_container_el.attr(CurrentModeTracking.ATTR_NAME, val)
}
// endregion Implementation Details


export default ee
